export const GameType = {
  1: 'Exhibition',
  2: 'Regular Season',
  3: 'Tournament',
  4: 'Playoff',
  5: 'Preliminary',
  6: 'Round Robin',
  7: 'Quarterfinal',
  8: 'Semifinal',
  9: 'Final',
  10: 'Consolation Final',
  11: 'Championship',
  12: 'Consolation',
  13: 'Championship Semifinal',
  14: 'Consolation Semifinal',
  15: 'Bronze Final',
}
